// extracted by mini-css-extract-plugin
export default {"advertTab":"w1b1WrHQ"};